// @flow
import React from 'react';

import Checkbox from 'app/common/ui/Checkbox';
import styles from './ECartItemCheck.module.scss';;


type Props = {
  id: number | string,
  checked: boolean,
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void,
  disabled?: boolean,
  label: string,
}

const ECartItemCheck = ({ id, onChange, checked, disabled, label }: Props) => (
  <div className={styles.root}>
    <Checkbox
      id={String(id)}
      label={label}
      hideLabel
      onChange={onChange}
      value={String(id)}
      checked={checked}
      disabled={disabled}
    />
  </div>
);

export default ECartItemCheck;
